// extracted by mini-css-extract-plugin
export default {"analyes":"Home_analyes__+SoR9"};